module.exports = __webpack_public_path__ + "img/ic_topic_news.a2ea096e.svg";